import { render, staticRenderFns } from "./SliderImagem.vue?vue&type=template&id=1c0b147a&scoped=true&"
import script from "./SliderImagem.vue?vue&type=script&lang=js&"
export * from "./SliderImagem.vue?vue&type=script&lang=js&"
import style0 from "./SliderImagem.vue?vue&type=style&index=0&id=1c0b147a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b147a",
  null
  
)

export default component.exports